module.exports = __webpack_public_path__ + "albania.svg?673a2c7bef3f7e0a156df5ed5f2d72d8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/albania.svg
// module id = 87
// module chunks = 10